


























import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";

@Component({ components: { RightDrawer } })
export default class Settings extends Vue {
  @Getter("calendar/isLoading") loading?: boolean;
  @Getter("calendar/settingsOpen") settingsOpen?: boolean;
  @Getter("auth/claims") claims?: JwtClaims;

  @Getter("isDarkTheme") isDarkTheme?: boolean;

  @Getter("appParams/tenantUsesAvailabilityChangelog")
  tenantUsesAvailabilityChangelogParam?: boolean;

  @Action("calendar/openSettings") open?: () => void;

  @Action("calendar/toggleAvailabilityTimelineOpenOnClick")
  toggleAvailabilityTimelineOpenOnClick?: (value: boolean) => void;
  @Getter("calendar/availabilityTimelineOpenOnClick")
  availabilityTimelineOpenOnClick?: boolean;
  get openAvailabilityTimelineOnClick() {
    return this.availabilityTimelineOpenOnClick ?? false;
  }

  get tenantUsesAvailabilityChangelog() {
    return this.tenantUsesAvailabilityChangelogParam ?? false;
  }

  get isOwner() {
    return policyChecker("IS_OWNER_ROLE")(this.claims);
  }
}
